(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-size-guide')) {
    customElements.define('product-size-guide', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          const description = document.getElementById(this.dataset.target);
          const table = description?.querySelector('table');
          if (!table) return;
          event.preventDefault();
          let ancestor = table.parentElement;
          while (ancestor) {
            if (ancestor.tagName === 'DETAILS') ancestor.open = true;
            ancestor = ancestor.parentElement;
          }
          const heading = table.previousElementSibling;
          const destination = heading?.matches('h2,h3,h4') ? heading : table;
          destination.setAttribute('tabindex', '-1');
          requestAnimationFrame(() => {
            destination.focus({ preventScroll: true });
            destination.scrollIntoView({ block: 'start', behavior: 'instant' });
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
